/**
 * @fileoverview gRPC-Web generated client stub for TranslatePdf
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.TranslatePdf = require('./translateService_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.TranslatePdf.TranslateServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.TranslatePdf.TranslateServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.DelTmpRequest,
 *   !proto.TranslatePdf.DelTmpResponse>}
 */
const methodDescriptor_TranslateService_delTmp = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/delTmp',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.DelTmpRequest,
  proto.TranslatePdf.DelTmpResponse,
  /**
   * @param {!proto.TranslatePdf.DelTmpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.DelTmpResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.DelTmpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.DelTmpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.DelTmpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.delTmp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/delTmp',
      request,
      metadata || {},
      methodDescriptor_TranslateService_delTmp,
      callback);
};


/**
 * @param {!proto.TranslatePdf.DelTmpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.DelTmpResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.delTmp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/delTmp',
      request,
      metadata || {},
      methodDescriptor_TranslateService_delTmp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.TransTmpRequest,
 *   !proto.TranslatePdf.TransTmpResponse>}
 */
const methodDescriptor_TranslateService_transTmp = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/transTmp',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.TransTmpRequest,
  proto.TranslatePdf.TransTmpResponse,
  /**
   * @param {!proto.TranslatePdf.TransTmpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.TransTmpResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.TransTmpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.TransTmpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.TransTmpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.transTmp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/transTmp',
      request,
      metadata || {},
      methodDescriptor_TranslateService_transTmp,
      callback);
};


/**
 * @param {!proto.TranslatePdf.TransTmpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.TransTmpResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.transTmp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/transTmp',
      request,
      metadata || {},
      methodDescriptor_TranslateService_transTmp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.SelectTmpRequest,
 *   !proto.TranslatePdf.SelectTmpResponse>}
 */
const methodDescriptor_TranslateService_selectTmp = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/selectTmp',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.SelectTmpRequest,
  proto.TranslatePdf.SelectTmpResponse,
  /**
   * @param {!proto.TranslatePdf.SelectTmpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.SelectTmpResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.SelectTmpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.SelectTmpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.SelectTmpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.selectTmp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/selectTmp',
      request,
      metadata || {},
      methodDescriptor_TranslateService_selectTmp,
      callback);
};


/**
 * @param {!proto.TranslatePdf.SelectTmpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.SelectTmpResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.selectTmp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/selectTmp',
      request,
      metadata || {},
      methodDescriptor_TranslateService_selectTmp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.UploadTmpRequest,
 *   !proto.TranslatePdf.UpLoadTmpResponse>}
 */
const methodDescriptor_TranslateService_uploadTmp = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/uploadTmp',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.UploadTmpRequest,
  proto.TranslatePdf.UpLoadTmpResponse,
  /**
   * @param {!proto.TranslatePdf.UploadTmpRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.UpLoadTmpResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.UploadTmpRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.UpLoadTmpResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.UpLoadTmpResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.uploadTmp =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/uploadTmp',
      request,
      metadata || {},
      methodDescriptor_TranslateService_uploadTmp,
      callback);
};


/**
 * @param {!proto.TranslatePdf.UploadTmpRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.UpLoadTmpResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.uploadTmp =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/uploadTmp',
      request,
      metadata || {},
      methodDescriptor_TranslateService_uploadTmp);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.UploadRequest,
 *   !proto.TranslatePdf.UpLoadResponse>}
 */
const methodDescriptor_TranslateService_upload = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/upload',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.UploadRequest,
  proto.TranslatePdf.UpLoadResponse,
  /**
   * @param {!proto.TranslatePdf.UploadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.UpLoadResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.UploadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.UpLoadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.UpLoadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.upload =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/upload',
      request,
      metadata || {},
      methodDescriptor_TranslateService_upload,
      callback);
};


/**
 * @param {!proto.TranslatePdf.UploadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.UpLoadResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.upload =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/upload',
      request,
      metadata || {},
      methodDescriptor_TranslateService_upload);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.UploadRequest,
 *   !proto.TranslatePdf.UpLoadResponse>}
 */
const methodDescriptor_TranslateService_uploadImg = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/uploadImg',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.UploadRequest,
  proto.TranslatePdf.UpLoadResponse,
  /**
   * @param {!proto.TranslatePdf.UploadRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.UpLoadResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.UploadRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.UpLoadResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.UpLoadResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.uploadImg =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/uploadImg',
      request,
      metadata || {},
      methodDescriptor_TranslateService_uploadImg,
      callback);
};


/**
 * @param {!proto.TranslatePdf.UploadRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.UpLoadResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.uploadImg =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/uploadImg',
      request,
      metadata || {},
      methodDescriptor_TranslateService_uploadImg);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.UploadConvertPDFRequest,
 *   !proto.TranslatePdf.UploadConvertPDFResponse>}
 */
const methodDescriptor_TranslateService_uploadConvertPDF = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/uploadConvertPDF',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.UploadConvertPDFRequest,
  proto.TranslatePdf.UploadConvertPDFResponse,
  /**
   * @param {!proto.TranslatePdf.UploadConvertPDFRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.UploadConvertPDFResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.UploadConvertPDFRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.UploadConvertPDFResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.UploadConvertPDFResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.uploadConvertPDF =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/uploadConvertPDF',
      request,
      metadata || {},
      methodDescriptor_TranslateService_uploadConvertPDF,
      callback);
};


/**
 * @param {!proto.TranslatePdf.UploadConvertPDFRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.UploadConvertPDFResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.uploadConvertPDF =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/uploadConvertPDF',
      request,
      metadata || {},
      methodDescriptor_TranslateService_uploadConvertPDF);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.FileListRequest,
 *   !proto.TranslatePdf.FileListResponse>}
 */
const methodDescriptor_TranslateService_fileList = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/fileList',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.FileListRequest,
  proto.TranslatePdf.FileListResponse,
  /**
   * @param {!proto.TranslatePdf.FileListRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.FileListResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.FileListRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.FileListResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.FileListResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.fileList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/fileList',
      request,
      metadata || {},
      methodDescriptor_TranslateService_fileList,
      callback);
};


/**
 * @param {!proto.TranslatePdf.FileListRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.FileListResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.fileList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/fileList',
      request,
      metadata || {},
      methodDescriptor_TranslateService_fileList);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.DeleteFileRequest,
 *   !proto.TranslatePdf.DeleteFileResponse>}
 */
const methodDescriptor_TranslateService_deleteFile = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/deleteFile',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.DeleteFileRequest,
  proto.TranslatePdf.DeleteFileResponse,
  /**
   * @param {!proto.TranslatePdf.DeleteFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.DeleteFileResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.DeleteFileRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.DeleteFileResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.DeleteFileResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.deleteFile =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/deleteFile',
      request,
      metadata || {},
      methodDescriptor_TranslateService_deleteFile,
      callback);
};


/**
 * @param {!proto.TranslatePdf.DeleteFileRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.DeleteFileResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.deleteFile =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/deleteFile',
      request,
      metadata || {},
      methodDescriptor_TranslateService_deleteFile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.ReadingFileRequest,
 *   !proto.TranslatePdf.ReadingFileResponse>}
 */
const methodDescriptor_TranslateService_readingFile = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/readingFile',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.TranslatePdf.ReadingFileRequest,
  proto.TranslatePdf.ReadingFileResponse,
  /**
   * @param {!proto.TranslatePdf.ReadingFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.ReadingFileResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.ReadingFileRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.ReadingFileResponse>}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.readingFile =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/TranslatePdf.TranslateService/readingFile',
      request,
      metadata || {},
      methodDescriptor_TranslateService_readingFile);
};


/**
 * @param {!proto.TranslatePdf.ReadingFileRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.ReadingFileResponse>}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.readingFile =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/TranslatePdf.TranslateService/readingFile',
      request,
      metadata || {},
      methodDescriptor_TranslateService_readingFile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.ReadingFileRequest,
 *   !proto.TranslatePdf.ReadingFileResponse>}
 */
const methodDescriptor_TranslateService_downLoadFile = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/downLoadFile',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.TranslatePdf.ReadingFileRequest,
  proto.TranslatePdf.ReadingFileResponse,
  /**
   * @param {!proto.TranslatePdf.ReadingFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.ReadingFileResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.ReadingFileRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.ReadingFileResponse>}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.downLoadFile =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/TranslatePdf.TranslateService/downLoadFile',
      request,
      metadata || {},
      methodDescriptor_TranslateService_downLoadFile);
};


/**
 * @param {!proto.TranslatePdf.ReadingFileRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.ReadingFileResponse>}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.downLoadFile =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/TranslatePdf.TranslateService/downLoadFile',
      request,
      metadata || {},
      methodDescriptor_TranslateService_downLoadFile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.ReadingFileRequest,
 *   !proto.TranslatePdf.ReadingFileResponse>}
 */
const methodDescriptor_TranslateService_downLoadConvertFile = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/downLoadConvertFile',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.TranslatePdf.ReadingFileRequest,
  proto.TranslatePdf.ReadingFileResponse,
  /**
   * @param {!proto.TranslatePdf.ReadingFileRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.ReadingFileResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.ReadingFileRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.ReadingFileResponse>}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.downLoadConvertFile =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/TranslatePdf.TranslateService/downLoadConvertFile',
      request,
      metadata || {},
      methodDescriptor_TranslateService_downLoadConvertFile);
};


/**
 * @param {!proto.TranslatePdf.ReadingFileRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.ReadingFileResponse>}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.downLoadConvertFile =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/TranslatePdf.TranslateService/downLoadConvertFile',
      request,
      metadata || {},
      methodDescriptor_TranslateService_downLoadConvertFile);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.StatusRequest,
 *   !proto.TranslatePdf.StatusResponse>}
 */
const methodDescriptor_TranslateService_checkStatus = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/checkStatus',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.StatusRequest,
  proto.TranslatePdf.StatusResponse,
  /**
   * @param {!proto.TranslatePdf.StatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.StatusResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.StatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.StatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.StatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.checkStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkStatus',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkStatus,
      callback);
};


/**
 * @param {!proto.TranslatePdf.StatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.StatusResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.checkStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkStatus',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.DocumentRequest,
 *   !proto.TranslatePdf.DocumentResponse>}
 */
const methodDescriptor_TranslateService_getDocument = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/getDocument',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.DocumentRequest,
  proto.TranslatePdf.DocumentResponse,
  /**
   * @param {!proto.TranslatePdf.DocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.DocumentResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.DocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.DocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.DocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.getDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getDocument',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getDocument,
      callback);
};


/**
 * @param {!proto.TranslatePdf.DocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.DocumentResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.getDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getDocument',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.DetailRequest,
 *   !proto.TranslatePdf.DetailResponse>}
 */
const methodDescriptor_TranslateService_getDetail = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/getDetail',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.DetailRequest,
  proto.TranslatePdf.DetailResponse,
  /**
   * @param {!proto.TranslatePdf.DetailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.DetailResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.DetailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.DetailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.DetailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.getDetail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getDetail',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getDetail,
      callback);
};


/**
 * @param {!proto.TranslatePdf.DetailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.DetailResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.getDetail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getDetail',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getDetail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.ProDocumentRequest,
 *   !proto.TranslatePdf.ProDocumentResponse>}
 */
const methodDescriptor_TranslateService_getProDocument = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/getProDocument',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.ProDocumentRequest,
  proto.TranslatePdf.ProDocumentResponse,
  /**
   * @param {!proto.TranslatePdf.ProDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.ProDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.ProDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.ProDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.ProDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.getProDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getProDocument',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getProDocument,
      callback);
};


/**
 * @param {!proto.TranslatePdf.ProDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.ProDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.getProDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getProDocument',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getProDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.UploadCountRequest,
 *   !proto.TranslatePdf.UploadCountResponse>}
 */
const methodDescriptor_TranslateService_checkUploadCountByDay = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/checkUploadCountByDay',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.UploadCountRequest,
  proto.TranslatePdf.UploadCountResponse,
  /**
   * @param {!proto.TranslatePdf.UploadCountRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.UploadCountResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.UploadCountRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.UploadCountResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.UploadCountResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.checkUploadCountByDay =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkUploadCountByDay',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkUploadCountByDay,
      callback);
};


/**
 * @param {!proto.TranslatePdf.UploadCountRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.UploadCountResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.checkUploadCountByDay =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkUploadCountByDay',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkUploadCountByDay);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.ReadDocumentRequest,
 *   !proto.TranslatePdf.ReadDocumentResponse>}
 */
const methodDescriptor_TranslateService_checkReadDocument = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/checkReadDocument',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.ReadDocumentRequest,
  proto.TranslatePdf.ReadDocumentResponse,
  /**
   * @param {!proto.TranslatePdf.ReadDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.ReadDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.ReadDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.ReadDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.ReadDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.checkReadDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkReadDocument',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkReadDocument,
      callback);
};


/**
 * @param {!proto.TranslatePdf.ReadDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.ReadDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.checkReadDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkReadDocument',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkReadDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.UploadTipRequest,
 *   !proto.TranslatePdf.UploadTipResponse>}
 */
const methodDescriptor_TranslateService_getUploadTip = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/getUploadTip',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.UploadTipRequest,
  proto.TranslatePdf.UploadTipResponse,
  /**
   * @param {!proto.TranslatePdf.UploadTipRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.UploadTipResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.UploadTipRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.UploadTipResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.UploadTipResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.getUploadTip =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getUploadTip',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getUploadTip,
      callback);
};


/**
 * @param {!proto.TranslatePdf.UploadTipRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.UploadTipResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.getUploadTip =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getUploadTip',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getUploadTip);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.SubmitRequest,
 *   !proto.TranslatePdf.SubmitResponse>}
 */
const methodDescriptor_TranslateService_submit = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/submit',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.SubmitRequest,
  proto.TranslatePdf.SubmitResponse,
  /**
   * @param {!proto.TranslatePdf.SubmitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.SubmitResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.SubmitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.SubmitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.SubmitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.submit =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/submit',
      request,
      metadata || {},
      methodDescriptor_TranslateService_submit,
      callback);
};


/**
 * @param {!proto.TranslatePdf.SubmitRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.SubmitResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.submit =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/submit',
      request,
      metadata || {},
      methodDescriptor_TranslateService_submit);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.SubmitRequest,
 *   !proto.TranslatePdf.SubmitResponse>}
 */
const methodDescriptor_TranslateService_submitPro = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/submitPro',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.SubmitRequest,
  proto.TranslatePdf.SubmitResponse,
  /**
   * @param {!proto.TranslatePdf.SubmitRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.SubmitResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.SubmitRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.SubmitResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.SubmitResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.submitPro =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/submitPro',
      request,
      metadata || {},
      methodDescriptor_TranslateService_submitPro,
      callback);
};


/**
 * @param {!proto.TranslatePdf.SubmitRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.SubmitResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.submitPro =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/submitPro',
      request,
      metadata || {},
      methodDescriptor_TranslateService_submitPro);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.SubmitConvertRequest,
 *   !proto.TranslatePdf.SubmitConvertResponse>}
 */
const methodDescriptor_TranslateService_submitConvert = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/submitConvert',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.SubmitConvertRequest,
  proto.TranslatePdf.SubmitConvertResponse,
  /**
   * @param {!proto.TranslatePdf.SubmitConvertRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.SubmitConvertResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.SubmitConvertRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.SubmitConvertResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.SubmitConvertResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.submitConvert =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/submitConvert',
      request,
      metadata || {},
      methodDescriptor_TranslateService_submitConvert,
      callback);
};


/**
 * @param {!proto.TranslatePdf.SubmitConvertRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.SubmitConvertResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.submitConvert =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/submitConvert',
      request,
      metadata || {},
      methodDescriptor_TranslateService_submitConvert);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.QueryDocumentRequest,
 *   !proto.TranslatePdf.QueryDocumentResponse>}
 */
const methodDescriptor_TranslateService_queryDocument = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/queryDocument',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.QueryDocumentRequest,
  proto.TranslatePdf.QueryDocumentResponse,
  /**
   * @param {!proto.TranslatePdf.QueryDocumentRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.QueryDocumentResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.QueryDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.QueryDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.QueryDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.queryDocument =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/queryDocument',
      request,
      metadata || {},
      methodDescriptor_TranslateService_queryDocument,
      callback);
};


/**
 * @param {!proto.TranslatePdf.QueryDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.QueryDocumentResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.queryDocument =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/queryDocument',
      request,
      metadata || {},
      methodDescriptor_TranslateService_queryDocument);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.PayRequest,
 *   !proto.TranslatePdf.PayResponse>}
 */
const methodDescriptor_TranslateService_checkPay = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/checkPay',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.PayRequest,
  proto.TranslatePdf.PayResponse,
  /**
   * @param {!proto.TranslatePdf.PayRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.PayResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.PayRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.PayResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.PayResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.checkPay =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkPay',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkPay,
      callback);
};


/**
 * @param {!proto.TranslatePdf.PayRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.PayResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.checkPay =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkPay',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkPay);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.ParentPowerRequest,
 *   !proto.TranslatePdf.ParentPowerResponse>}
 */
const methodDescriptor_TranslateService_checkParentPower = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/checkParentPower',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.ParentPowerRequest,
  proto.TranslatePdf.ParentPowerResponse,
  /**
   * @param {!proto.TranslatePdf.ParentPowerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.ParentPowerResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.ParentPowerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.ParentPowerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.ParentPowerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.checkParentPower =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkParentPower',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkParentPower,
      callback);
};


/**
 * @param {!proto.TranslatePdf.ParentPowerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.ParentPowerResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.checkParentPower =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkParentPower',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkParentPower);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.TransTextRequest,
 *   !proto.TranslatePdf.TransTextResponse>}
 */
const methodDescriptor_TranslateService_submitTransText = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/submitTransText',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.TransTextRequest,
  proto.TranslatePdf.TransTextResponse,
  /**
   * @param {!proto.TranslatePdf.TransTextRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.TransTextResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.TransTextRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.TransTextResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.TransTextResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.submitTransText =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/submitTransText',
      request,
      metadata || {},
      methodDescriptor_TranslateService_submitTransText,
      callback);
};


/**
 * @param {!proto.TranslatePdf.TransTextRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.TransTextResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.submitTransText =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/submitTransText',
      request,
      metadata || {},
      methodDescriptor_TranslateService_submitTransText);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.CheckRoamingRequest,
 *   !proto.TranslatePdf.CheckRoamingResponse>}
 */
const methodDescriptor_TranslateService_checkRoaming = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/checkRoaming',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.CheckRoamingRequest,
  proto.TranslatePdf.CheckRoamingResponse,
  /**
   * @param {!proto.TranslatePdf.CheckRoamingRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.CheckRoamingResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.CheckRoamingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.CheckRoamingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.CheckRoamingResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.checkRoaming =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkRoaming',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkRoaming,
      callback);
};


/**
 * @param {!proto.TranslatePdf.CheckRoamingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.CheckRoamingResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.checkRoaming =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/checkRoaming',
      request,
      metadata || {},
      methodDescriptor_TranslateService_checkRoaming);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.SendEmailRequest,
 *   !proto.TranslatePdf.SendEmailResponse>}
 */
const methodDescriptor_TranslateService_sendEmail = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/sendEmail',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.SendEmailRequest,
  proto.TranslatePdf.SendEmailResponse,
  /**
   * @param {!proto.TranslatePdf.SendEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.SendEmailResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.SendEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.SendEmailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.SendEmailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.sendEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/sendEmail',
      request,
      metadata || {},
      methodDescriptor_TranslateService_sendEmail,
      callback);
};


/**
 * @param {!proto.TranslatePdf.SendEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.SendEmailResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.sendEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/sendEmail',
      request,
      metadata || {},
      methodDescriptor_TranslateService_sendEmail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.GetEmailRequest,
 *   !proto.TranslatePdf.GetEmailResponse>}
 */
const methodDescriptor_TranslateService_getEmail = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/getEmail',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.GetEmailRequest,
  proto.TranslatePdf.GetEmailResponse,
  /**
   * @param {!proto.TranslatePdf.GetEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.GetEmailResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.GetEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.GetEmailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.GetEmailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.getEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getEmail',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getEmail,
      callback);
};


/**
 * @param {!proto.TranslatePdf.GetEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.GetEmailResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.getEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getEmail',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getEmail);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.GetCarouselRequest,
 *   !proto.TranslatePdf.GetCarouselResponse>}
 */
const methodDescriptor_TranslateService_getCarousel = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/getCarousel',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.GetCarouselRequest,
  proto.TranslatePdf.GetCarouselResponse,
  /**
   * @param {!proto.TranslatePdf.GetCarouselRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.GetCarouselResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.GetCarouselRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.GetCarouselResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.GetCarouselResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.getCarousel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getCarousel',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getCarousel,
      callback);
};


/**
 * @param {!proto.TranslatePdf.GetCarouselRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.GetCarouselResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.getCarousel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getCarousel',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getCarousel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.GetActivityNoticeRequest,
 *   !proto.TranslatePdf.GetActivityNoticeResponse>}
 */
const methodDescriptor_TranslateService_getActivityNotice = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/getActivityNotice',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.GetActivityNoticeRequest,
  proto.TranslatePdf.GetActivityNoticeResponse,
  /**
   * @param {!proto.TranslatePdf.GetActivityNoticeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.GetActivityNoticeResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.GetActivityNoticeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.GetActivityNoticeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.GetActivityNoticeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.getActivityNotice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getActivityNotice',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getActivityNotice,
      callback);
};


/**
 * @param {!proto.TranslatePdf.GetActivityNoticeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.GetActivityNoticeResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.getActivityNotice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getActivityNotice',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getActivityNotice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.GetMedicineDictRequest,
 *   !proto.TranslatePdf.GetMedicineDictResponse>}
 */
const methodDescriptor_TranslateService_getMedicineDict = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/getMedicineDict',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.GetMedicineDictRequest,
  proto.TranslatePdf.GetMedicineDictResponse,
  /**
   * @param {!proto.TranslatePdf.GetMedicineDictRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.GetMedicineDictResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.GetMedicineDictRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.GetMedicineDictResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.GetMedicineDictResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.getMedicineDict =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getMedicineDict',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getMedicineDict,
      callback);
};


/**
 * @param {!proto.TranslatePdf.GetMedicineDictRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.GetMedicineDictResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.getMedicineDict =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/getMedicineDict',
      request,
      metadata || {},
      methodDescriptor_TranslateService_getMedicineDict);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.SelectMedicineDictSpecRequest,
 *   !proto.TranslatePdf.SelectMedicineDictSpecResponse>}
 */
const methodDescriptor_TranslateService_selectMedicineDictSpec = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/selectMedicineDictSpec',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.SelectMedicineDictSpecRequest,
  proto.TranslatePdf.SelectMedicineDictSpecResponse,
  /**
   * @param {!proto.TranslatePdf.SelectMedicineDictSpecRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.SelectMedicineDictSpecResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.SelectMedicineDictSpecRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.SelectMedicineDictSpecResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.SelectMedicineDictSpecResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.selectMedicineDictSpec =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/selectMedicineDictSpec',
      request,
      metadata || {},
      methodDescriptor_TranslateService_selectMedicineDictSpec,
      callback);
};


/**
 * @param {!proto.TranslatePdf.SelectMedicineDictSpecRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.SelectMedicineDictSpecResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.selectMedicineDictSpec =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/selectMedicineDictSpec',
      request,
      metadata || {},
      methodDescriptor_TranslateService_selectMedicineDictSpec);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.AiSessionPageRequest,
 *   !proto.TranslatePdf.AiSessionPageResponse>}
 */
const methodDescriptor_TranslateService_aiSessionPage = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/aiSessionPage',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.AiSessionPageRequest,
  proto.TranslatePdf.AiSessionPageResponse,
  /**
   * @param {!proto.TranslatePdf.AiSessionPageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.AiSessionPageResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.AiSessionPageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.AiSessionPageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.AiSessionPageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.aiSessionPage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/aiSessionPage',
      request,
      metadata || {},
      methodDescriptor_TranslateService_aiSessionPage,
      callback);
};


/**
 * @param {!proto.TranslatePdf.AiSessionPageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.AiSessionPageResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.aiSessionPage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/aiSessionPage',
      request,
      metadata || {},
      methodDescriptor_TranslateService_aiSessionPage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.DelAiSessionRequest,
 *   !proto.TranslatePdf.DelAiSessionResponse>}
 */
const methodDescriptor_TranslateService_delAiSession = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/delAiSession',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.DelAiSessionRequest,
  proto.TranslatePdf.DelAiSessionResponse,
  /**
   * @param {!proto.TranslatePdf.DelAiSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.DelAiSessionResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.DelAiSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.DelAiSessionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.DelAiSessionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.delAiSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/delAiSession',
      request,
      metadata || {},
      methodDescriptor_TranslateService_delAiSession,
      callback);
};


/**
 * @param {!proto.TranslatePdf.DelAiSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.DelAiSessionResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.delAiSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/delAiSession',
      request,
      metadata || {},
      methodDescriptor_TranslateService_delAiSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.CreateAiSessionRequest,
 *   !proto.TranslatePdf.CreateAiSessionResponse>}
 */
const methodDescriptor_TranslateService_createAiSession = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/createAiSession',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.CreateAiSessionRequest,
  proto.TranslatePdf.CreateAiSessionResponse,
  /**
   * @param {!proto.TranslatePdf.CreateAiSessionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.CreateAiSessionResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.CreateAiSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.CreateAiSessionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.CreateAiSessionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.createAiSession =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/createAiSession',
      request,
      metadata || {},
      methodDescriptor_TranslateService_createAiSession,
      callback);
};


/**
 * @param {!proto.TranslatePdf.CreateAiSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.CreateAiSessionResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.createAiSession =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/createAiSession',
      request,
      metadata || {},
      methodDescriptor_TranslateService_createAiSession);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.AiHistoryPageRequest,
 *   !proto.TranslatePdf.AiHistoryPageResponse>}
 */
const methodDescriptor_TranslateService_aiHistoryPage = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/aiHistoryPage',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.AiHistoryPageRequest,
  proto.TranslatePdf.AiHistoryPageResponse,
  /**
   * @param {!proto.TranslatePdf.AiHistoryPageRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.AiHistoryPageResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.AiHistoryPageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.AiHistoryPageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.AiHistoryPageResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.aiHistoryPage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/aiHistoryPage',
      request,
      metadata || {},
      methodDescriptor_TranslateService_aiHistoryPage,
      callback);
};


/**
 * @param {!proto.TranslatePdf.AiHistoryPageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.AiHistoryPageResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.aiHistoryPage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/aiHistoryPage',
      request,
      metadata || {},
      methodDescriptor_TranslateService_aiHistoryPage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.AiSendRequest,
 *   !proto.TranslatePdf.AiSendResponse>}
 */
const methodDescriptor_TranslateService_aiSend = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/aiSend',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.AiSendRequest,
  proto.TranslatePdf.AiSendResponse,
  /**
   * @param {!proto.TranslatePdf.AiSendRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.AiSendResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.AiSendRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.AiSendResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.AiSendResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.aiSend =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/aiSend',
      request,
      metadata || {},
      methodDescriptor_TranslateService_aiSend,
      callback);
};


/**
 * @param {!proto.TranslatePdf.AiSendRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.AiSendResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.aiSend =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/aiSend',
      request,
      metadata || {},
      methodDescriptor_TranslateService_aiSend);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.AiTransRequest,
 *   !proto.TranslatePdf.AiTransResponse>}
 */
const methodDescriptor_TranslateService_aiTrans = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/aiTrans',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.AiTransRequest,
  proto.TranslatePdf.AiTransResponse,
  /**
   * @param {!proto.TranslatePdf.AiTransRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.AiTransResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.AiTransRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.AiTransResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.AiTransResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.aiTrans =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/aiTrans',
      request,
      metadata || {},
      methodDescriptor_TranslateService_aiTrans,
      callback);
};


/**
 * @param {!proto.TranslatePdf.AiTransRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.AiTransResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.aiTrans =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/aiTrans',
      request,
      metadata || {},
      methodDescriptor_TranslateService_aiTrans);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.TransTextHistoryRequest,
 *   !proto.TranslatePdf.TransTextHistoryResponse>}
 */
const methodDescriptor_TranslateService_transTextHistory = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/transTextHistory',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.TransTextHistoryRequest,
  proto.TranslatePdf.TransTextHistoryResponse,
  /**
   * @param {!proto.TranslatePdf.TransTextHistoryRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.TransTextHistoryResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.TransTextHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.TransTextHistoryResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.TransTextHistoryResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.transTextHistory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/transTextHistory',
      request,
      metadata || {},
      methodDescriptor_TranslateService_transTextHistory,
      callback);
};


/**
 * @param {!proto.TranslatePdf.TransTextHistoryRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.TransTextHistoryResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.transTextHistory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/transTextHistory',
      request,
      metadata || {},
      methodDescriptor_TranslateService_transTextHistory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.DeleteAllRequest,
 *   !proto.TranslatePdf.DeleteAllResponse>}
 */
const methodDescriptor_TranslateService_deleteAll = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/deleteAll',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.DeleteAllRequest,
  proto.TranslatePdf.DeleteAllResponse,
  /**
   * @param {!proto.TranslatePdf.DeleteAllRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.DeleteAllResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.DeleteAllRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.DeleteAllResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.DeleteAllResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.deleteAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/deleteAll',
      request,
      metadata || {},
      methodDescriptor_TranslateService_deleteAll,
      callback);
};


/**
 * @param {!proto.TranslatePdf.DeleteAllRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.DeleteAllResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.deleteAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/deleteAll',
      request,
      metadata || {},
      methodDescriptor_TranslateService_deleteAll);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.TranslatePdf.DeleteOneRequest,
 *   !proto.TranslatePdf.DeleteOneResponse>}
 */
const methodDescriptor_TranslateService_deleteOne = new grpc.web.MethodDescriptor(
  '/TranslatePdf.TranslateService/deleteOne',
  grpc.web.MethodType.UNARY,
  proto.TranslatePdf.DeleteOneRequest,
  proto.TranslatePdf.DeleteOneResponse,
  /**
   * @param {!proto.TranslatePdf.DeleteOneRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.TranslatePdf.DeleteOneResponse.deserializeBinary
);


/**
 * @param {!proto.TranslatePdf.DeleteOneRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.TranslatePdf.DeleteOneResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.TranslatePdf.DeleteOneResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.TranslatePdf.TranslateServiceClient.prototype.deleteOne =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/TranslatePdf.TranslateService/deleteOne',
      request,
      metadata || {},
      methodDescriptor_TranslateService_deleteOne,
      callback);
};


/**
 * @param {!proto.TranslatePdf.DeleteOneRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.TranslatePdf.DeleteOneResponse>}
 *     Promise that resolves to the response
 */
proto.TranslatePdf.TranslateServicePromiseClient.prototype.deleteOne =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/TranslatePdf.TranslateService/deleteOne',
      request,
      metadata || {},
      methodDescriptor_TranslateService_deleteOne);
};


module.exports = proto.TranslatePdf;
